<template lang="pug">
    div
      a.btn.btn-primary(href=link_href ,@click="onClick", style="color: white; margin-top:10px;") {{btn_label}}
      div.d-flex.align-items-center
        HeatmapDomain(v-if="show_modal", @close-modal="show_modal = false")
    </template>
  
  <script>
  //libs
  import HeatmapDomain from "./modals/heatmap_domain.vue";
  
  export default {
    props: {
      link_href: {type: String, default: "" },
      btn_label: {type: String, default: "" },
      has_domain: {type: Boolean, default: false },
    },
    methods: {
      onClick(e){
        console.log(this.has_domain)
        if (!this.has_domain){
          e.preventDefault()
          this.show_modal = true
          return false
        }else{
          window.location.href = this.link_href
        }
      },
    },
    data(){
      return {
        show_modal: false,
      }
    },
    components: {
      HeatmapDomain,
    },
  }
  </script>